// ============================================================
// GANGING UP, ON THE MAP (plan design-gaps, Z1; the beats page's "faint
// threads and a +10? chip; pressed, they go solid"): when whoever acts is in
// reach of their target and others of their team stand in reach of it too,
// the bonus is there to take. This says who - the allies the threads run
// from. Gang Up stays the attacker's own toggle; the map only shows the offer.
//
// Pure. Zero React dependency. Metres.
// ============================================================

import type { Combatant } from '../roster/types';
import type { Token } from '../battlefield/tokens';
import { sameTeam, teamOf } from '../roster/team';
import { isInTheFight } from '../roster/inTheFight';
import { inMelee } from '../battlefield/reach';

/** In reach of each other: the map's own reach rule, height and all (a figure on a roof is not in it). */
const engaged = (a: Token, b: Token) => inMelee(a, b);

/**
 * Who of the actor's team stands in reach of the target beside them - the gang the actor may join - or null: no
 * actor or target on the map, the actor not in reach, no team, or nobody else there. The fallen do not gang up.
 */
export function gangUpOf(
  roster: readonly Combatant[],
  tokens: Readonly<Record<string, Token>>,
  actorId: string | null,
  targetId: string | null,
): { allies: string[] } | null {
  const actor = roster.find((c) => c.id === actorId);
  const [from, at] = [actorId ? tokens[actorId] : undefined, targetId ? tokens[targetId] : undefined];
  if (!actor || !teamOf(actor) || !from || !at || !engaged(from, at)) return null;
  const allies = roster
    .filter((c) => c.id !== actorId && c.id !== targetId && sameTeam(c, actor) && isInTheFight(c))
    .filter((c) => tokens[c.id] && engaged(tokens[c.id], at))
    .map((c) => c.id);
  return allies.length ? { allies } : null;
}
